import { render, staticRenderFns } from "./Regulations.vue?vue&type=template&id=330d8c26&scoped=true"
var script = {}
import style0 from "./Regulations.vue?vue&type=style&index=0&id=330d8c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d8c26",
  null
  
)

export default component.exports